import { render } from "./RequestManager.vue?vue&type=template&id=2778809b&scoped=true"
import script from "./RequestManager.vue?vue&type=script&lang=js"
export * from "./RequestManager.vue?vue&type=script&lang=js"

import "./RequestManager.vue?vue&type=style&index=0&id=2778809b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2778809b"]])

export default __exports__